var SchemaBuilder = /** @class */ (function () {
    function SchemaBuilder(schema, model, fieldName, attrs, listeners) {
        this.schema = schema;
        this.model = model;
        this.fieldName = fieldName;
        this.attrs = attrs;
        this.listeners = listeners;
    }
    SchemaBuilder.isFieldData = function (fieldContent) {
        return !fieldContent || typeof fieldContent === 'string' || typeof fieldContent === 'number';
    };
    SchemaBuilder.prototype.get = function () {
        var _a = this, model = _a.model, fieldName = _a.fieldName, attrs = _a.attrs, listeners = _a.listeners;
        return this.schema.fieldSet[this.fieldName]({ model: model, fieldName: fieldName, attrs: attrs, listeners: listeners });
    };
    SchemaBuilder.prototype.getData = function () {
        var fieldContent = this.get();
        if (SchemaBuilder.isFieldData(fieldContent)) {
            return fieldContent;
        }
        return null;
    };
    SchemaBuilder.prototype.getComponent = function () {
        var fieldContent = this.get();
        if (typeof fieldContent === 'object') {
            return fieldContent;
        }
        return null;
    };
    return SchemaBuilder;
}());

var Schema = /** @class */ (function () {
    function Schema() {
    }
    Object.defineProperty(Schema.prototype, "allFields", {
        get: function () {
            return Object.keys(this.fieldSet);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Schema.prototype, "allHeaders", {
        get: function () {
            var _this = this;
            return this.allFields.map(function (fieldName) { return _this.translateFrom(fieldName); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Schema.prototype, "header", {
        get: function () {
            var _this = this;
            return Object.keys(this.fieldSet).reduce(function (result, key) {
                result[key] = _this.translateFrom(key);
                return result;
            }, {});
        },
        enumerable: true,
        configurable: true
    });
    Schema.prototype.build = function (model, fieldName, attrs, listeners) {
        return new SchemaBuilder(this, model, fieldName, attrs, listeners);
    };
    Schema.prototype.fieldByType = function (item, fieldData, translateKeys) {
        var _this = this;
        return this.allFields.reduce(function (res, field) {
            var fieldContent = _this.build(item, field).get();
            if (SchemaBuilder.isFieldData(fieldContent) === fieldData) {
                res[translateKeys ? _this.translateFrom(field) : field] = fieldContent;
            }
            return res;
        }, {});
    };
    Schema.prototype.fieldData = function (item, translateKeys) {
        return this.fieldByType(item, true, translateKeys);
    };
    Schema.prototype.fieldComponent = function (item, translateKeys) {
        return this.fieldByType(item, false, translateKeys);
    };
    Schema.prototype.fieldDataList = function (list, translateKeys) {
        var _this = this;
        return list.map(function (item) { return _this.fieldData(item, translateKeys); });
    };
    Schema.prototype.fieldComponentList = function (list, translateKeys) {
        var _this = this;
        return list.map(function (item) { return _this.fieldComponent(item, translateKeys); });
    };
    return Schema;
}());

export { Schema, SchemaBuilder };
//# sourceMappingURL=meta-schema.es5.js.map
